<template>
  <div class="order-query-container">
    <BannerCarousel :banners="banner" :interval="5000" :arrow="'hover'" />
    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="container">
        <div class="search-form">
          <el-input v-model="waybill_num" placeholder="请输入面单号" size="large" clearable
            @keyup.enter.native="handleSearch">
            <template #append>
              <el-button type="primary" size="large" @click="handleSearch" :loading="searchLoading">
                <i class="el-icon-search"></i> 搜索
              </el-button>
            </template>
          </el-input>
        </div>
      </div>
    </div>
    <!-- 结果区域 -->
    <div class="result-section">
      <div class="container">
        <!-- 搜索结果 -->
        <div v-if="searchResult" v-for="item in searchResult" :key="item.waybill_num" class="order-result">
          <div class="flex align-center justify-between order-header">
            <span>订单号：{{ item.order_sn }}</span>
            <span class="header_time">录入时间：{{ item.create_time }}</span>
          </div>
          <div class="flex align-center justify-between" style="margin-top: 20px;">
            <div class="flex flex-wrap align-center justify-between" style="width: 70%;">
              <div class="flex flex-direction align-center justify-center">
                <div class="addr_title">{{ item.address[0].area_city.name }}</div>
                <div class="addr_content">{{ item.address[0].cus_name }}</div>
              </div>
              <div class="flex flex-direction align-center justify-center">
                <img src="@/assets/images/5.png" class="address-icon" />
                <div class="delivery_status">{{ item.order_status_name }}</div>
              </div>
              <div class="flex flex-direction align-center justify-center">
                <div class="addr_title">{{ item.address[1].area_city.name }}</div>
                <div class="addr_content">{{ item.address[1].cus_name }}</div>
              </div>
            </div>
            <el-button type="text" size="medium" @click="handleDetail(item)">查看详情</el-button>
          </div>
        </div>
        <div v-if="searchResult.length == 0 && !searchLoading" class="default-tip">
          <el-empty description="请输入面单号查询订单信息" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeData, getOrderList } from '@/api/home.js'
import BannerCarousel from '@/components/BannerCarousel.vue'
export default {
  name: 'OrderQuery',
  components: {
    BannerCarousel
  },
  data() {
    return {
      banner: [],//轮播图数据
      waybill_num: '',//面单号
      searchLoading: false,
      searchResult: [],
    }
  },
  computed: {

  },
  mounted() {
    this.getHomeData();
  },
  methods: {
    // 查看详情点击事件
    handleDetail(item) {
      this.$router.push({
        path: '/order-detail',
        query: {
          aid: item.aid
        }
      })
    },
    getHomeData() {
      getHomeData({}).then(res => {
        if (res.code == '1') {
          this.banner = res.data.lb;
        }
      })
    },
    handleSearch() {
      if (!this.waybill_num) {
        this.$message.warning('请输入面单号')
        return
      }
      this.searchLoading = true;
      // 调用订单查询接口
      getOrderList({
        waybill_num: this.waybill_num
      }).then(res => {
        if (res.code == '1') {
          this.searchResult = res.data;
        } else {
          this.$message.info(res.msg || '未找到相关订单信息')
        }
        this.searchLoading = false;
      })
    },
  }
}
</script>

<style scoped>
.order-query-container {
  width: 100%;
  background-color: #fff;
  padding-bottom: 30px;
}

/* 搜索区域 */
.search-btn {
  background-color: #409eff;
}

.search-section {
  background-color: #fff;
  padding: 50px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.search-form {
  max-width: 600px;
  margin: 0 auto;
}

/* 结果区域 */
.default-tip {
  margin-top: 50px;
  text-align: center;
}

.order-result {
  width: 100%;
  background: #F8FAFB;
  border-radius: 16px 16px 16px 16px;
  padding: 24px;
  margin-bottom: 30px;
}

.order-header {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}

.header_time {
  color: #999;
}

.addr_title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 22px;
  color: #333333;
}

.address-icon {
  width: 42px;
  height: 14px;
}

.delivery_status {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #5C95E0;
  margin-top: 10px;
}

.addr_content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-overlay h2 {
    font-size: 32px;
  }

  .hero-overlay p {
    font-size: 16px;
  }

  .order-basic {
    flex-direction: column;
    gap: 15px;
  }

  .info-item {
    min-width: auto;
  }
}
</style>